import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import SurveyTemplateList from './SurveyTemplateList';
import { hasText } from '../../utils/hasText';
import BlankTemplate from './BlankTemplate';

const SurveyCategoryList = ({
  surveyTemplatesList,
  viewSurveyDetail,
  selectSurvey,
  isTemplateSelected,
  filterCategory,
  searchText
}) => {
  const list = surveyTemplatesList.map(({ id, name, survey_templates: surveyTemplates }) => {
    const displayClass = filterCategory.id && filterCategory.id !== id ? 'd-none' : null;

    const surveyTempsWithQues = surveyTemplates
      .filter(st => st.question_count > 0);
    if (surveyTempsWithQues.length < 1) {
      return null;
    }

    const visibleSurveyTemplates = surveyTempsWithQues.map((surveyTemplate) => {
      const isShown = !searchText
        || (searchText && hasText([surveyTemplate.name], searchText));

      if (isTemplateSelected(surveyTemplate) || !isShown) {
        return null;
      }
      return surveyTemplate;
    }).filter(x => x);

    if (visibleSurveyTemplates.length < 1) {
      return null;
    }

    return (
      <div className={`${displayClass}`}>
        <div className="d-flex template-category-container align-items-center">
          <span className="template-category-icon d-none">
            <FontAwesomeIcon icon="circle" size="2x" />
          </span>
          <span className="template-category-title">{name}</span>
        </div>
        <div>
          <SurveyTemplateList
            surveyTemplates={visibleSurveyTemplates}
            viewSurveyDetail={viewSurveyDetail}
            selectSurvey={selectSurvey}
            isTemplateSelected={isTemplateSelected}
          />
        </div>
      </div>
    );
  });

  return (
    <div className="survey-category-list">
      {list}
      <BlankTemplate
        viewSurveyDetail={viewSurveyDetail}
        isTemplateSelected={isTemplateSelected}
        selectSurvey={selectSurvey}
      />
    </div>
  );
};

SurveyCategoryList.propTypes = {
  surveyTemplatesList: PropTypes.shape([]),
  viewSurveyDetail: PropTypes.func,
  selectSurvey: PropTypes.func,
  isTemplateSelected: PropTypes.func,
  filterCategory: PropTypes.shape({
    id: PropTypes.number
  }),
  searchText: PropTypes.string
};

SurveyCategoryList.defaultProps = {
  surveyTemplatesList: [],
  viewSurveyDetail: () => { },
  selectSurvey: () => { },
  isTemplateSelected: () => { },
  filterCategory: {},
  searchText: ''
};

export default SurveyCategoryList;



// WEBPACK FOOTER //
// ./src/components/survey-templates/SurveyCategoryList.js